import { gql } from '@apollo/client'

//Lookup Queries
export const GET_APP_BANNERS = gql`
   query GetAppBanners($bannerFilter: AppBannerFilterInput!, $page: PageInput!) {
  getAppBanners(banner_filter: $bannerFilter, page: $page) {
    code
    success
    message
    total_count
    app_banners {
      id
      image {
        mobile {
          file_name
          size
          mime_type
          s3_key
        }
        tablet {
          file_name
          size
          mime_type
          s3_key
        }
      }
      valid_from
      valid_to
      is_active
      category
      country_code
      banner_info {
      banner_name
        title {
          en
          ar
        }
        description {
          en
          ar
        }
        trip_tag
        link_url
      }
    }
  }
}
`
export const GET_LOCATION_LIST = gql`
    query searchLocation($searchLocationId: String, $searchString: String, $page: PageInput!) {
        searchLocation(id: $searchLocationId, search_string: $searchString, page: $page) {
            code
            success
            message
            total_count
            locations {
                id
                name {
                    en
                    ar
                }
                address {
                    unit_no
                    road_no
                    block_no
                    area
                    landmark
                    country_code
                }
                geo {
                    lat
                    lng
                }
                contact {
                    email
                    phone_number
                }
                country_details {
                    country_code
                    country
                    country_ar
                    is_gcc
                }
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
            }
        }
    }
`
export const GET_COUNTRY_LIST = gql`
    query Country($code: String) {
        country(code: $code) {
            alpha_iso2
            country
            country_ar
            is_gcc
        }
    }
`

export const GET_ROUTE_TYPE_LIST = gql`
    query RouteType($code: String) {
        routeType(code: $code) {
            code
            description {
                en
                ar
            }
        }
    }
`

export const GET_MEALS_LIST = gql`
    query SearchMeal($page: PageInput!, $searchMealId: String, $name: String) {
        searchMeal(page: $page, id: $searchMealId, name: $name) {
            code
            success
            message
            meals {
                meal_id
                description {
                    en
                    ar
                }
                price {
                    tax
                    base
                }
                active
            }
            total_count
        }
    }
`

export const GET_MEAL_DETAILS_FROM_TRIP = gql`
    query GetMealDetailsFromTripByTripIdForPublicApp($tripId: NonEmptyString!, $travelDate: LocalDate!) {
        getMealDetailsFromTripByTripIdForPublicApp(trip_id: $tripId, travel_date: $travelDate) {
            code
            success
            message 
            trip_meals {
                trip_meal_id
                trip_id 
                meal_detail {
                    meal_id
                    description {
                        en
                        ar
                    }
                    price {
                        base
                        tax
                    }
                    active 
                } 
            }
        }
    }
`

export const GET_FEEDBACK_LIST = gql`
    query GetFeedbackResponses($filter: FeedbackResponseInput!, $page: PageInput!) {
        getFeedbackResponses(filter: $filter, page: $page) {
            code
            success
            message
            total_count
            feedback_responses {
                response_id
                response_info {
                    booking_id
                    travel_date
                }
                response {
                    question_id
                    order_no
                    question_text {
                        en
                        ar
                    }
                    user_value
                    question_type
                }
                admin_action {
                    action_taken
                    action_by
                    action_date
                    remarks
                }
                submitted_at
                service_code {
                    code
                    description {
                        en
                        ar
                    }
                }
            }
        }
    }
`
export const GET_WATER_METRO_FROM_LOCATION = gql`
    query WaterMetroFromLocation($locationFilter: WaterMetroLocationInput!) {
        waterMetroFromLocation(locationFilter: $locationFilter) {
            code
            success
            message
            locations {
                id
                name {
                    en
                    ar
                }
                address {
                    unit_no
                    road_no
                    block_no
                    contact
                    area
                    landmark
                }
                geo {
                    lat
                    lng
                }
            }
        }
    }
`

export const GET_WATER_METRO_TO_LOCATION = gql`
    query WaterMetroToLocation($fromLocationId: NonEmptyString!, $routeType: RouteType!) {
        waterMetroToLocation(from_location_id: $fromLocationId, route_type: $routeType) {
            code
            success
            message
            locations {
                id
                name {
                    en
                    ar
                }
                address {
                    unit_no
                    road_no
                    block_no
                    contact
                    area
                    landmark
                }
                geo {
                    lat
                    lng
                }
            }
        }
    }
`

export const GET_SEARCH_TRIP = gql`
    query searchTrip($searchfilter: [WaterMetroSearchInput!]!, $prefered_current_type: CurrencyCode!, $previous_selected_trip_details: PreviousSelectedTripDetailsInput, $bookingTripType: BookingTripType) {
        searchTrip(searchfilter: $searchfilter, prefered_current_type: $prefered_current_type, previous_selected_trip_details: $previous_selected_trip_details, booking_trip_type: $bookingTripType) {
            code
            success
            message
            trips {
                trip_date
                route_id
                route {
                    route_id
                    route_name {
                        en
                        ar
                    }
                    route_trip {
                        trip_id
                        trip_name {
                            en
                            ar
                        }
                        start_time
                        end_time
                        schedule {
                            stop_number
                            arrival_time
                            departure_time
                            location {
                                id
                                name {
                                    en
                                    ar
                                }
                            }
                        }
                    }
                    waypoints {
                        location {
                            name {
                                ar
                                en
                            }
                            id
                        }
                        stop_number
                    }
                }
                trip_id
                trip {
                    trip_id
                    trip_name {
                        en
                        ar
                    }
                    start_time
                    schedule {
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                        stop_number
                        arrival_time
                        departure_time
                    }
                    end_time
                }
                start {
                    location_id
                    stop_number
                    arrival_time
                    departure_time
                    location {
                        id
                        name {
                            en
                            ar
                        }
                    }
                    trip_arrival_time
                    trip_departure_time
                }
                end {
                    location_id
                    stop_number
                    arrival_time
                    departure_time
                    location {
                        id
                        name {
                            en
                            ar
                        }
                    }
                    trip_arrival_time
                    trip_departure_time
                }
                available_seats {
                    code
                    description {
                        en
                        ar
                    }
                    available
                }
                user_preferred_currency_code
                price {
                    seat_type_code
                    user_preferred_consolidated_price {
                        ADL
                        CHD
                        INF
                        SNR
                    }
                    stop_price {
                        stop_number
                        price {
                            ADL
                            CHD
                            INF
                            SNR
                        }
                        start_location_id
                        end_location_id
                    }
                }
                middle_stops {
                    location_id
                    stop_number
                    arrival_time
                    departure_time
                    location {
                        id
                        name {
                            en
                            ar
                        }
                    }
                    trip_arrival_time
                    trip_departure_time
                }
                duration_minutes
                shuttle_providers {
                    route_shuttle_id
                    route_id
                    shuttle_provider {
                        provider_id
                        provider_name
                        service_description {
                            en
                            ar
                        }
                        contact {
                            person
                            mobile_number
                            email
                            address
                        }
                        country_code
                        price {
                            base
                            tax
                            gross
                        }
                        isactive
                    }
                }
            }
        }
    }
`

export const GET_SEARCH_RETURN_TRIP = gql`
    query searchReturnTrip($searchfilter: [WaterMetroSearchInput!]!, $prefered_current_type: CurrencyCode!, $previous_selected_trip_details: PreviousSelectedTripDetailsInput!, $bookingTripType: BookingTripType) {
        searchTrip(searchfilter: $searchfilter, prefered_current_type: $prefered_current_type, previous_selected_trip_details: $previous_selected_trip_details, booking_trip_type: $bookingTripType) {
            code
            success
            message
            trips {
                trip_date
                route_id
                route {
                    route_id
                    route_name {
                        en
                        ar
                    }
                    route_trip {
                        trip_id
                        trip_name {
                            en
                            ar
                        }
                        start_time
                        end_time
                        schedule {
                            stop_number
                            arrival_time
                            departure_time
                            location {
                                id
                                name {
                                    en
                                    ar
                                }
                            }
                        }
                    }
                    waypoints {
                        location {
                            name {
                                ar
                                en
                            }
                            id
                        }
                        stop_number
                    }
                }
                trip_id
                trip {
                    trip_id
                    trip_name {
                        en
                        ar
                    }
                    start_time
                    schedule {
                        location {
                            id
                            name {
                                en
                                ar
                            }
                        }
                        stop_number
                        arrival_time
                        departure_time
                    }
                    end_time
                }
                start {
                    location_id
                    stop_number
                    arrival_time
                    departure_time
                    location {
                        id
                        name {
                            en
                            ar
                        }
                    }
                    trip_arrival_time
                    trip_departure_time
                }
                end {
                    location_id
                    stop_number
                    arrival_time
                    departure_time
                    location {
                        id
                        name {
                            en
                            ar
                        }
                    }
                    trip_arrival_time
                    trip_departure_time
                }
                available_seats {
                    code
                    description {
                        en
                        ar
                    }
                    available
                }
                user_preferred_currency_code
                price {
                    seat_type_code
                    user_preferred_consolidated_price {
                        ADL
                        CHD
                        INF
                        SNR
                    }
                    stop_price {
                        stop_number
                        price {
                            ADL
                            CHD
                            INF
                            SNR
                        }
                        start_location_id
                        end_location_id
                    }
                }
                middle_stops {
                    location_id
                    stop_number
                    arrival_time
                    departure_time
                    location {
                        id
                        name {
                            en
                            ar
                        }
                    }
                    trip_arrival_time
                    trip_departure_time
                }
                duration_minutes
                shuttle_providers {
                    route_shuttle_id
                    route_id
                    shuttle_provider {
                        provider_id
                        provider_name
                        service_description {
                            en
                            ar
                        }
                        contact {
                            person
                            mobile_number
                            email
                            address
                        }
                        country_code
                        price {
                            base
                            tax
                            gross
                        }
                        isactive
                    }
                }
            }
        }
    }
`

export const GET_SYSTEM_CONFIG = gql`
    query GetSystemConfigs($settingName: NonEmptyString) {
        getSystemConfigs(setting_name: $settingName) {
            code
            success
            message
            system_configs {
                setting_name
                setting_value {
                    value
                    description
                }
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
            }
        }
    }
`
export const GET_SYS_CONF_SERVICE_PAYMENT = gql`
    query GetServicePayments($serviceCode: NonEmptyString) {
        getServicePayments(service_code: $serviceCode) {
            code
            success
            message
            service_payments {
                service_code
                service {
                    code
                    description {
                        en
                        ar
                    }
                }
                payment_options {
                    CASH
                    WALLET
                    DEBIT_CARD
                    CREDIT_CARD
                    APPLE_PAY
                    GOOGLE_PAY
                }
            }
        }
    }
`
export const GET_ROUTE_PRICE_DISCOUNT = gql`
    query GetRoutePriceDiscounts($filter: RoutePriceDiscountsFilterInput!, $page: PageInput!) {
        getRoutePriceDiscounts(filter: $filter, page: $page) {
            code
            success
            message
            total_count
            route_price_discounts {
                discount_id
                discount_code
                discount_conditions {
                    age_to
                    age_from
                    seat_type
                    nationality_code
                    nationality {
                        alpha_iso2
                        country
                        country_ar
                        is_gcc
                    }
                    special_needs
                    route_type
                    route_details {
                        code
                        description {
                            en
                            ar
                        }
                    }
                    country_code
                    country_details {
                        alpha_iso2
                        country
                        country_ar
                        is_gcc
                    }
                }
                discount_value {
                    type
                    value
                }
                status {
                    code
                    description {
                        en
                        ar
                    }
                }
                user_audit {
                    created_by
                    created_date
                    modified_by
                    modified_date
                }
                discount_desc {
                    en
                    ar
                }
                valid_from
                valid_to
            }
        }
    }
`

export const GET_ADD_ON_PRICE_CONFIG = gql`
    query GetAddOnPriceConfig($routeId: NonEmptyString!, $tripId: NonEmptyString!, $tripDate: LocalDate!) {
        getAddOnPriceConfig(route_id: $routeId, trip_id: $tripId, trip_date: $tripDate) {
            code
            success
            message
            total_count
            add_on_details {
                extra_luggage {
                    price
                    weight_kg
                }
               
            }
        }
    }
`
